import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=2b36b314&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=2b36b314&prod&scoped=true&lang=css&"
import style1 from "./SelectInput.vue?vue&type=style&index=1&id=2b36b314&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36b314",
  null
  
)

export default component.exports